export var getDefaultStyleSheet = () => ({
  rootStyle: {}
});
//# sourceMappingURL=getDefaultStyleSheet.js.map